import { queryOptions, useQuery } from '@tanstack/react-query';

import { getAllServices, getPublicServices, getServiceById } from '@/lib/api/service';

import { queryKeys } from './query-keys-factory';

/**
 * Query Options Factories
 */
export const serviceQueries = {
  /**
   * Get all services
   */
  all: () =>
    queryOptions({
      queryKey: queryKeys.services.list(),
      queryFn: getAllServices,
      staleTime: 1000 * 60 * 10, // 10 minutes
      retry: false,
    }),

  /**
   * Get public services (show_public = true)
   */
  public: () =>
    queryOptions({
      queryKey: queryKeys.services.list({ showPublic: true }),
      queryFn: getPublicServices,
      staleTime: 1000 * 60 * 10,
      retry: false,
    }),

  /**
   * Get service by ID
   */
  byId: (id: string) =>
    queryOptions({
      queryKey: queryKeys.services.detail(id),
      queryFn: () => getServiceById(id),
      staleTime: 1000 * 60 * 10,
      enabled: !!id,
      retry: false,
    }),
};

/**
 * Query Hooks
 */

/**
 * Hook to fetch all services
 */
export const useGetAllServices = () => useQuery(serviceQueries.all());

/**
 * Hook to fetch public services
 */
export const useGetPublicServices = () => useQuery(serviceQueries.public());

/**
 * Hook to fetch service by ID
 */
export const useGetServiceById = (id: string) => useQuery(serviceQueries.byId(id));
